import React, { memo } from 'react';
import styled from '@emotion/styled';
import { IAirline } from '@move-frontend/dap';
import { Column, ColumnHeader } from './Column';

interface IProps {
	airline?: IAirline;
	icaoOperatingAirline: string;
	role?: 'columnheader' | 'cell';
}

export const StyledAirlineColumn = styled(
	({ role = 'columnheader', ...props }) =>
		role === 'columnheader' ? (
			<ColumnHeader {...props} />
		) : (
			<Column {...props} />
		),
)`
	max-width: 80px;

	@media (max-width: 600px) {
		display: none;
	}

	img {
		width: 48px;
	}
`;

export const AirlineColumn = memo(
	({ airline, icaoOperatingAirline, role }: IProps) => (
		<StyledAirlineColumn role={role}>
			{airline && airline.squareLogo ? (
				<img src={airline.squareLogo} alt={airline.name} />
			) : airline && airline.name ? (
				<span>{airline.name}</span>
			) : (
				<span>{icaoOperatingAirline}</span>
			)}
		</StyledAirlineColumn>
	),
);
